import script from "./Reset.vue?vue&type=script&setup=true&lang=js"
export * from "./Reset.vue?vue&type=script&setup=true&lang=js"

import "./Reset.vue?vue&type=style&index=0&id=54e90055&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e90055"]])

export default __exports__